import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { rootReducer, rootSaga } from "./RootReducer";
import createSagaMiddleware from "redux-saga";
import { errorMiddleWare } from "setup/middleware/ErrorMiddleware";
import cplAuthSignalRMiddleware from "signalR/cplAuthSignalRMiddleware";
import cpl3SignalRMiddleware from "signalR/cpl3SignalRMiddleware";

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware, errorMiddleWare, cplAuthSignalRMiddleware, cpl3SignalRMiddleware];

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false, thunk: true }).concat(middleware),
  devTools: process.env.NODE_ENV !== "production",
});

export type AppDispatch = typeof store.dispatch;

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
